import React from 'react';
import PropTypes from 'prop-types';
import PrimaryButtonComponent from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  TransactionCompleteSection,
  TransactionMain,
} from '../../../OnlineTraining/Purchase/Course.styles';
import PageHelmet from '../../../Components/PageHelmet/HelmetHelper.component';
const CompleteTransactionCompany = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Retrieve transaction details passed via state
  const {
    transactionId,
    total,
    tax,
    discountCode,
    discountAmount,
    grandTotal,
    users,
    courseName,
    billingAddress,
  } = location.state || {};

  if (!transactionId) {
    // If no transaction details are available, redirect back to the purchase page
    navigate('/purchase');
    return null;
  }

  return (
    <TransactionMain>
      <PageHelmet
        title="Purchase Complete"
        description="Course has been purchased and the confirmation number
      "
      />
      <TransactionCompleteSection>
        <h2>Transaction Complete</h2>
        <p>
          Thank you for your purchase! Your transaction has been successfully
          processed. You will shortly recieve an email of confirmation, if you
          do not recieve an email, please check your spam folder or contact us.
        </p>
        <p>
          <strong>Transaction ID:</strong> {transactionId}
        </p>
      </TransactionCompleteSection>
      <TransactionCompleteSection>
        <h4>Purchased Course:</h4>
        {courseName}
        <ul>
          {users.map((u) => (
            <li key={u._id}>
              <strong>{u.firstName + u.lastName}</strong>
            </li>
          ))}
        </ul>
      </TransactionCompleteSection>
      <TransactionCompleteSection>
        <h4>Billing Address:</h4>
        <p>
          {billingAddress.street}
          {billingAddress.addressLine2 && <br />}
          {billingAddress.addressLine2}
          <br />
          {billingAddress.city}, {billingAddress.province}{' '}
          {billingAddress.postalCode}
          <br />
          {billingAddress.countryCode || 'CA'}
        </p>
      </TransactionCompleteSection>
      <TransactionCompleteSection>
        <h4>Order Summary:</h4>
        <p>Toal: ${Number(total || 0?.toFixed(2))}</p>
        {discountCode && (
          <p>
            {discountCode} Discount: -${Number(discountAmount || 0)?.toFixed(2)}
          </p>
        )}
        <p>Tax: ${Number(tax || 0)?.toFixed(2)}</p>
        <p>
          <strong>Total:</strong> ${Number(grandTotal || 0?.toFixed(2))}
        </p>
        <PrimaryButtonComponent
          span="Go to your Company Dashboard"
          functionName={() => navigate('/company')}
        />
        <p className="m1T" style={{ textAlign: 'center' }}>
          If you have any questions, please contact us at
          yodasafetyservices1@outlook.com.
        </p>
      </TransactionCompleteSection>
    </TransactionMain>
  );
};

CompleteTransactionCompany.propTypes = {
  transactionId: PropTypes.string,
  course: PropTypes.object,
  users: PropTypes.array,
  billingAddress: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
    adminArea1: PropTypes.string,
    adminArea2: PropTypes.string,
    countryCode: PropTypes.string,
    postalCode: PropTypes.string,
  }),
  total: PropTypes.number,
  tax: PropTypes.number,
  grandTotal: PropTypes.number,
};

export default CompleteTransactionCompany;
